'use client';
import React from 'react';

interface Props {
  error?: string;
}

export const InputError = ({ error }: Props) => {
  if (!error) {
    return null;
  }

  return <span className="text-xs text-red-500">{error}</span>;
};
export default InputError;
